
// Libraries
var React = require('react');

// Styles
require('./PlayersTitle.scss');

class PlayersTitle extends React.Component {
	render() {
		return (
			<h2 className="PlayersTitle">{this.props.title}</h2>
		)
	}
}

module.exports = PlayersTitle;


// WEBPACK FOOTER //
// ./src/components/Players/PlayersTitle.js